import Vue from "vue";
import axios from "axios";
import * as helper from "./api/helper";
import api from "./api/url";

export async function loadMasterData() {
  const tokenKey = helper.default?.tokenEnum()?.access_token;
  const token = localStorage.getItem(tokenKey) || "";

  if (token) {
    try {
      const res = await axios.post(api.masterData);
      const data = res?.data;
      const refData = {
        ...data,
        categories:
          (data?.categories &&
            data?.categories.length &&
            helper.default.mapCategoryHierarchy(data?.categories)) ||
          [],
      };
      Vue.prototype.$master = refData;
    } catch (err) {
      Vue.prototype.$master = {};
    }
  } else {
    Vue.prototype.$master = {};
  }

  if (token) {
    try {
      const res = await axios.post(api.crmMasterData);
      const data = res?.data;

      const refData = {
        ...data,
        categories:
          (data?.categories &&
            data?.categories.length &&
            helper.default.mapCategoryHierarchy(data?.categories)) ||
          [],
      };
      Vue.prototype.$masterCrm = refData;
    } catch (err) {
      Vue.prototype.$masterCrm = {};
    }
  } else {
    Vue.prototype.$masterCrm = {};
  }
}
